import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import Btn from "../components/Btn/Btn";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Scenery = () => {
  return (
    <React.Fragment>
      <SEO title="Scenery | ICSI 2022" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Scenery"
        content="For Participants"
        contentTwo="Scenery"
        linkage="/"

      />

      <EmptyTwo>
        {/* <div className="entry-content title-center">
          <h2>The information is to be announced. </h2>
        </div> */}
        <div className="entry-content2">
          {/* <div className="ch-lang-en">
          <Link className="btn btn-primary" to={process.env.PUBLIC_URL + "/scenery_zn"}>Chinese</Link>
          </div> */}
          <div className="space-50"></div>
          <h2>About Shenzhen</h2>
          <br></br>
          <p className="font-black font-bold" align="justify">
            Nearly 50 years ago, Shenzhen was little more than a market town, but it has evolved into a city of more than 12 million people and one of China&apos;s top retail destinations. Many visitors arrive in Shenzhen to take advantage of its multitudes of shopping centers and stores that sell just about anything you can imagine. It&apos;s a great city to buy hand-tailored clothing, art replicas, and high-tech toys.
            <br></br>
            <br></br>


          </p>

          <p className="font-black font-bold" align="justify">
            AS a hotbed of high tech, the city&apos;s pillar industry, the Shenzhen Hi-Tech Industrial Park has expanded from its core location in Nanshan District into an area of 159 square kilometers encompassing several separate locations, including Pingshan, Longgang, Bao&apos;an and Longhua districts.



            The expanded Shenzhen Hi-Tech Industrial Park is one of six national pilot zones for building world-class high-tech parks and is the second-largest national high-tech zone in terms of size. It ranks No. 2 in GDP among the 157 national high-tech parks, surpassed only by Zhongguancun in Beijing.



            Shenzhen&apos;s high-tech industry started in 1996 in Nanshan after the Shenzhen Hi-Tech Industrial Park, an area of 11.5 square kilometers, was approved by the State science commission.



            In 2002, the industrial output value of the city&apos;s high-tech industry reached 71.9 billion yuan (US$10 billion), equal to about 20 percent of the city&apos;s total industrial output.



            In 2011, the industrial output value of the Shenzhen Hi-Tech Industrial Park reached 405.4 billion yuan, 40 times its value from when it was founded in 1996.



            It yielded 24.4 billion yuan of GDP and 4.3 billion yuan of tax revenue per square kilometer in 2018, the greatest share among its counterparts in the country.



            The expanded high-tech park has five locations, and houses more than 60 percent of Shenzhen&apos;s total number of high-tech enterprises.
          </p>

          <div className="title-center">
            <img
              src="./images/shenzhen/tencent.jpg"
              alt="tencent"
              width="90%"
            />
          </div>
          <br></br>
          <div className="title-center">
            <img
              src="./images/shenzhen/hi-tech.jpg"
              alt="hi-tech"
              width="90%"
            />
          </div>


          <br></br>

          <p className="font-black font-bold" align="justify">
            The city connects Hong Kong to China&apos;s mainland and is one of the largest and most popular cities in southeast China. It is best known for shopping and entertainment, thanks to its large malls and many family-friendly amusement parks. Whether you&apos;re passing through or plan to spend a few days in Shenzhen, there is much more to see beyond the shops. Whether you take some time to enjoy recreational gardens and golf courses or go on a gastronomic adventure through the city&apos;s many street food zones, Shenzhen has a lot to offer.
            <br />
            <br />
          </p>


          <div className="title-center">
            <img
              src="./images/shenzhen/night.jpg"
              alt="shenzhen-night"
              width="90%"
            />
          </div>

          <br></br>
          <br></br>
          <br></br>

          <h3>Attractions in Shenzhen</h3>
          <br></br>
          <li>
            <a href="#talent-park">Shenzhen Talent Park</a>
          </li>
          <li>
            <a href="#windows">Shenzhen Window of the World</a>
          </li>
          <li>
            <a href="#folk-village">China Folk Culture Village</a>
          </li>
          <li>
            <a href="#wutong">Wutong Mountain Scenic Area</a>
          </li>
          <li>
            <a href="#dameisha">Dameisha Beach</a>
          </li>
          {/* <li>
            <a href="#shenzhenbay">Shenzhen Bay Park</a>
          </li> */}



          <br />
          <br />
          <h4 id="talent-park">Shenzhen Talent Park</h4>
          <p align="justify">


            The project is located in Houhai Area, Nanshan, Shenzhen. It is adjacent to Shahe West Road in the east, Keyuan Avenue and Dengliang Road in the west, Haide 3rd Road in the north and Dongbin Road in the south. The park covers an area of 77 hectares, including 31 hectares of lake.



            The park is the first park in China with the theme of awarding and motivating talents. The talent element of modern art is an important space characteristic of the park.

            <br></br>
            <br></br>


            The lake&apos;s water source comes from the outer sea and the city center river. Its daily housing capacity is about 600,000 cubic meters. By arranging different plants for freshwater wetlands, rain gardens and seawater wetlands a beautiful scenery is formed, which also optimizes the water environment habitat. The flexible vertical design ensures the adaptability of the park to rainwater management in extreme weather conditions. The different scales of space around the waterfront provide a variety of relationship experiences between people and water, realizing people&apos;s natural intimacy with water. The park also functions as a theater of time and city life, hosting various acts every day.
            <br></br>
            <br></br>



            A variety of lakeside facilities have become the best place for local citizens to get a close touch with nature, including book bar, exhibition hall, a 2.7-kilometer-long blue jogging track, high-standard shower room, well-designed children&apos;s playground, the hydrophilic rocky beach and open lawn. Meanwhile, the park has also provided a good habitat for all kinds of birds. The scattered sandstone beach group on the lake is home to one stopover for migratory birds like pipers on their routes of twice-a-year migration. Bird piles in the lake together with a wide variety of flowering-like plants are also efforts to build a good biological habitat.
          </p>
          <p>
            <div className="title-center">
              <img
                src="./images/shenzhen/talent-park.jpg"
                alt="talent-park"
                width="90%"
              />
            </div>
          </p>
          <br></br>
          <br></br>
          <h4 id="windows">Shenzhen Window of the World</h4>
          <p align="justify">
            Covering an area of 480,000 square meters, Window of the World in Shenzhen is a large-scale theme park designed to show the essence of world&apos;s culture. In the park, you will see many replicas of landmarks in the world. Meanwhile, it is one of the most popular tourist attractions in Shenzhen.
            <br></br>
            <br></br>

            There are 8 zones in the park which vividly copy those iconic places in Asia, Europe, Oceania, Africa and America. This theme park features incredibly detailed reproductions of 130 major landmarks from the whole world, including Pyramids of Egypt, Leaning Tower of Pisa, Eiffel Tower of Paris and so on, some life-size and some much smaller (with the proportion of 1:1, 1:5, 1:15, etc.). Once come here, you will truly realize how much faster you could see the world - sort of - by visiting this theme park. No wonder it is called &quot;Window&quot; of the world.
          </p>
          <div className="title-center">
            <p>
              <img
                src="./images/shenzhen/windows.jpg"
                alt="windows of world"
                width="90%"
              />
              <br />
            </p>

          </div>

          <br></br>
          <br></br>

          <h4 id="folk-village">China Folk Culture Village</h4>
          <p align="justify">
            Folk Culture Villages in Nanshan District was formerly two scenic spots in Overseas China Town by Shenzhen Bay and were integrated as one in 2003. It is the world&apos;s largest and most comprehensive miniature park, reproducing nearly 100 famous tourist attractions in China and 25 full-scale ethnic villages. One can have a thorough lesson on the 5,000 years of Chinese history and appreciate beautiful landscapes from throughout the country in one day.

            In additional to the largest Han group, there are 55 ethnic minorities in China, distributed throughout many parts of the country. It is almost impossible to admire the architecture, folk activities, and snacks of most minorities during one day&apos;s trip. Folk Culture Villages, on the west of Splendid China, will help you achieve this dream. Twenty-five unique villages of 22 minorities have been reproduced there at a ratio of 1:1.
          </p>

          <div className="title-center">
            <p>
              <img src="./images/shenzhen/folk-village.jpg" alt="folk-village" width="90%" />

              <br />
            </p>

          </div>

          <br></br>
          <br></br>

          <h4 id="wutong">Wutong Mountain Scenic Area </h4>
          <p align="justify">
            With an area of 31.82 square kilometres, founded in 1989 and situated in central south part of Shenzhen, Mount Wutong National Park nears the Roc Bay of South China Sea in the east, connects Hong Kong in the south, borders on Shenzhen Reservoir in the west, approaches the secondary boundaries of the pre-Shenzhen Special Economic Zone in the north.
            <br></br>
            <br></br>

            Wutong Mountain is a rare natural scenic spot in China, which is located in urban area, with coastal mountains and natural vegetations as its main scenery. There are eight scenery blocks such as &quot;Musical Instrument in Phoenix Valley&quot;, &quot;Wutong Clouds&quot;, &quot;A Phoenix Perching on the Green Wutong&quot;, &quot;East Lake Park&quot; and &quot;Fairy Lake Botanical Garden&quot; etc. In 1993 it was awarded the title of National Park of Guangdong by the Guangdong Provincial Government. In December 2009, it was conferred the title of National Park of China by the State Council.
          </p>

          <div className="title-center">
            <p>
              <img
                src="./images/shenzhen/shenzhen2.jpg"
                alt="wutong"
                width="90%"
              />
              <br />
            </p>

          </div>

          <br></br>
          <br></br>

          <h4 id="dameisha">Dameisha Beach</h4>
          <p align="justify">
          Dameisha Beach Park is one of ten tangible things promoised by the Shenzhen government. Located in Yantan District of Shenzhen, Dameisha Seashore Park embraces the Mirs Bay and owns 1,800 meters long beach. Sun Square is located in the heart of the park while Moon Square lays in the west of the park. A 432-meter long passage connects these two parks. More than 50 kinds of subtropical trees are planted in the park, including coconut tree and palm, ect.. There are many functional zones in the park, like swimming zone, sport zone, amusement zone and BBQ zone.
          </p>
          <br></br>

          <div className="title-center">
            <p>
              <img src="./images/shenzhen/shenzhen3.jpg" alt="dameisha" width="90%" />
              <br />
            </p>

          </div>
          <br></br>
          <br></br>

          {/* <h4 id="shenzhenbay">Shenzhen Bay Park</h4>
          <p>Shenzhen Bay Park is a seaside urban park in Shenzhen. The park occupies a 13-kilometer-long stretch of reclaimed land along the southern coast of Shenzhen on the north shore of Shenzhen Bay (Deep Bay), starting west near Shenzhen Bay Bridge at Wanghai road and ending at the Hongshulin Nature Reserve. It spans much of the coastline of the Nanshan and Futian districts. It runs along much of the length of Binhai and Binhe Boulevards and occupies an area of 108.07 hectares (267.0518 acres).

        The park is divided into two sections, namely Shenzhen Bay Coastal Recreation Zone (深圳湾滨海休闲带) at its South West side and Hongshulin Coastal Ecological Park (红树林海滨生态公园) at its Eastern side. The latter is situated within the Hongshulin Nature Reserve, a habitat of numerous endangered bird species and is also known for its mangrove.

        The entire area of the park opened on August 6, 2011, days before the 2011 Summer Universiade that took place in Shenzhen. The Hongshulin Coastal Ecological Park was opened earlier in December 2000. The entire length of the park is motor vehicle-free. Cycle paths and picnic spaces are featured along the park. The park offers a panoramic view covering the Shenzhen skyline and New Territories, Hong Kong.
          </p>
        <br></br>
        <div className="title-center">
          <p>
            <img src="./images/xian/sc8.jpg" alt="shenzhenbay" width="100%" />
            <br />
          </p>
        </div> */}

        </div>
      </EmptyTwo>
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Scenery;
